const ASAAS_BADGE_URL =
    'https://baas.asaas.com/selos/Servicos_financeiros_Asaas-Reduzida-Positivo.svg?id=XQIDF9VL'

export default function AsaasBadge() {
    return (
        <div className="pagamento-panel-asaas">
            <a href="https://asaas.com" target="_blank" rel="noopener noreferrer">
                <img src={ASAAS_BADGE_URL} alt="Serviços financeiros Asaas" width="120" height="36" />
            </a>
        </div>
    )
}
